import api from '@pray/shared/utils/api';

import type { GetExperimentsResponse } from './types/api';
import type { GetExperimentsParams } from './types/app';

/**
 * Returns experiments based on the provided parameters
 * @param search - The search term
 * @param offset - The pagination offset
 * @param instance - The experiment instance
 * @param status - The experiment status
 * @param category - The experiment category
 * @param platform - The experiment platform
 * @param requireEntityDefinition - Whether to only return experiments with entity definitions
 * @param versionGroupName - The version group name to filter by
 * @param version - The specific version number to filter by
 * @param sortBy - The column to sort by
 * @param sortOrder - The sort direction
 */
export async function getExperiments({
  search,
  offset,
  instance,
  status,
  category,
  platform,
  requireEntityDefinition,
  versionGroupName,
  version,
  sortBy,
  sortOrder,
}: GetExperimentsParams) {
  const params: Record<string, string | number | boolean> = {};

  if (search) params.search = search;
  if (instance) params.instance_name = instance;
  if (status) params.status = status;
  if (offset) params.offset = offset;
  if (category) params.category = category;
  if (platform) params.platform = platform;
  if (requireEntityDefinition) params.require_entity_definition = true;
  if (versionGroupName) params.version_group_name = versionGroupName;
  if (version !== undefined) params.version = version;
  if (sortBy) params.sort_by = sortBy;
  if (sortOrder) params.sort_order = sortOrder;

  const url = '/web/studio/experiments';

  const response = await api.executeGetRequest<GetExperimentsResponse>(url, params);

  return response.data;
}
